import React from 'react';
import { Link } from 'react-router-dom';

import { Form, Input, Select, Radio } from '@bd-uikit-web/React/Form';
import SimpleModal from '@bd-uikit-web/React/SimpleModal';

import bdAuth from '@bd-uikit-web/js-helpers/bdAuth';
import bdReq from '@bd-uikit-web/js-helpers/bdReq';
import rootDispatcher from '@bd-uikit-web/js-helpers/rootDispatcher';
import FacebookLogin from 'react-facebook-login';

export default class Register extends React.Component {
  constructor(props) {
    super();
    this.props = props;

    this.state = {
      sending: false,
    };

    this.onFormSubmit = this.onFormSubmit.bind(this);

    this.days = [];
    for (let i = 1; i <= 31; i++) {
      this.days.push(i);
    }

    this.years = [];
    const baseYear = new Date().getFullYear();
    for (let i = 0; i <= 99; i++) {
      this.years.push(baseYear - i);
    }
  }

  componentWillMount() {
    if (bdAuth.isAuthenticated()) {
      this.redirect();
      return;
    }

    this.responseFacebook = (response) => {
      this.setStateSending();
      bdAuth.authenticate(null, null, response.accessToken)
        .then(({ success, body }) => {
          if (!success) {
            this.setState({
              sending: false,
            });

            rootDispatcher.dispatch('NB:OPEN', {
              type: 'error',
              msg: body.message,
            });
            return;
          }

          this.redirect();
        })
        .catch((err) => {
          /* Logging the error is consistent with bd-reseller-portal */
          console.log('FACEBOOK ERROR', err);
          this.setState({
            sending: false,
          });

          rootDispatcher.dispatch('NB:OPEN', {
            type: 'error',
            msg: `Whoops! Looks like something went wrong on our side.
                  Our support team has been notified. Try again later.`,
          });
        });
    };
  }

  onFormSubmit(data) {
    if (data.repeatEmail !== data.email) {
      rootDispatcher.dispatch('NB:OPEN', {
        type: 'error',
        msg: 'Your repeat email should match your email',
      });
      return;
    }

    const apiLink = '/users';
    const apiData = {
      email: data.email,
      password: data.password,
    };

    this.setStateSending();
    bdReq.post(apiLink, apiData)
      .then(({ success, body }) => {
        if (!success) {
          this.setState({
            sending: false,
          });

          rootDispatcher.dispatch('NB:OPEN', {
            type: 'error',
            msg: body.message,
          });
          return;
        }

        this.setState({
          sending: false,
        });

        // Redirect user to login page after successfully registering.
        this.redirectUser(data.email, data.password);
      }).catch((error) => {
        rootDispatcher.dispatch('NB:OPEN', {
          type: 'error',
          msg: 'Email already in use.',
        });

        this.setState({
          sending: false,
        });
      });
  }

  // @todo move this to a static global place.
  setStateSending() {
    this.setState({
      sending: true,
    });
  }

  redirect() {
    const redirectUrl = bdReq.getURLParameter('redirect-url');

    if (redirectUrl) {
      location.href = `${redirectUrl}`;
      return;
    }

    // Redirect user after successfull login to the overview page
    rootDispatcher.dispatch('LOGIN');
    this.props.history.push('/');
  }

  redirectUser(email, password) {
    bdAuth.authenticate(email, password)
      .then(({ success, body }) => {
        if (!success) {
          this.setState({
            sending: false,
          });

          rootDispatcher.dispatch('NB:OPEN', {
            type: 'error',
            msg: body.message,
          });
          return;
        }

        this.redirect();
      });
  }

  formatDate(year, month, day) {
    return `${year}-${month}-${day}`;
  }

  render() {
    return (
      <div className="m-bg-image">
        <div className="m-bg-wrapper">
          <img className="m-bg-logo" src="/assets/img/blackdove-logo.png" alt="Blackdove Logo" />
          <h1> The most efficient way to enjoy digital art. </h1>
          <div className="m-bg-container">
            <Form onSubmit={this.onFormSubmit}>
              <div className="m-bg-input-wrapper">
                <Input className="m-bg-input-style" type="text" name="email" placeholder="Email" invalidMsg="Please enter your email" required />
                <Input className="m-bg-input-style" type="text" name="repeatEmail" placeholder="Repeat email" invalidMsg="Please repeat your email" required />
                <Input className="m-bg-input-style" type="password" name="password" placeholder="Password" invalidMsg="Please enter a password" required />
              </div>
              <div className="m-bg-button-wrapper">
                <button className="m-bg-login-button" type="submit" disabled={this.state.sending}>
                  Sign up
                </button>
                <span className="m-bg-or">OR</span>

                <FacebookLogin
                  appId="189038304919308"
                  scope="public_profile,email"
                  fields="id,name,birthday,email,first_name,last_name,location"
                  callback={ this.responseFacebook }
                  cssClass="btn btn--facebook btn--text-lower"
                />
              </div>
            </Form>
          </div>
          <div className="form__group form__group--second-link"> */}
            <Link className="a--clean" to={`/${location.search}`}>
              <span className="m-bg-span">Already have an account? <u>Login</u></span>
            </Link>
          </div>
        </div>
      </div>
    );
  }
}
